import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { drugs } from '@services/api'

export class drugsStore extends StoreExt {
    @observable loading = false
    @observable drug = {}
    //#region for main page of drugs
    @observable list = []
    @observable families = []
    @observable companies = []
    @observable filters = {}
    //#endregion
    //#region for  popup showing prices of drug companies
    @observable list_DrugCompanies = []
    @observable filtered_DrugCompanies = []
    @observable filters_drugsCompanies = { company_id: null }
    //#endregion
    //#region for popup showing  drug companies not related to table drugs,which have drug_id null
    @observable list_DrugCompaniesNoHealthRight = []
    @observable filtered_DrugCompaniesNoHealthRight = []
    @observable filters_DrugCompaniesNoHealthRight = {
        drug_id: null,
        drug_company_type: null,
        company_name: null,
        policy_name: null
    }
    //#region for main page of drugs
    @observable paging = {
        page: 1,
        perPage: 0,
        total: 0,
        lastPage: 0,
        filters: {}
    }
    @observable errors = { serverErrors: null }
    //#endregion
    //#region for  popup showing  drug companies not related to table drugs,which have drug_id null
    @observable pagingDrugsNoHealthRight = {
        page: 1,
        perPage: 0,
        total: 0,
        lastPage: 0,
        filters_DrugCompaniesNoHealthRight: {
            drug_id: null,
            drug_company_type: null,
            company_name: null,
            policy_name: null
        }
    }
    @observable aliasesArray = []
    //#endregion
    @action
    getDrugs = async page => {
        this.loading = true
        const { perPage, total, lastPage, data, families, companies } = (
            await drugs.getList({ ...this.filters, page })
        ).data
        const filters = { ...this.filters }
        runInAction(() => {
            this.list = data
            this.paging = { perPage, total, page, lastPage, filters }
            this.filters = filters
            this.loading = false
            this.families = families.sort((a, b) => new Intl.Collator('he').compare(a.name, b.name))
            this.companies = companies
        })
    }

    @action
    updateAll = async () => {
        await this.getDrugs(this.paging.page)
        runInAction(() => {
            this.loading = false
        })
    }

    @action
    getDrug = async id => {
        this.loading = true
        const { drug } = (await drugs.getDrug({ id })).data
        runInAction(() => {
            this.drug = drug
            this.loading = false
            this.list_DrugCompanies = drug.drugCompanies
            this.filteredDrugCompaniesList()
        })
    }

    @action
    setAliasesArray = aliases => {
        const aliasesArray = aliases ? aliases.split('|') : []
        runInAction(() => {
            this.aliasesArray = aliasesArray
        })
    }

    @action
    changeAliasValue = (value, index) => {
        const newArray = [...this.aliasesArray]
        newArray[index] = value
        runInAction(() => {
            this.aliasesArray = newArray
        })
    }

    @action
    deleteAlias = index => {
        const newArray = [...this.aliasesArray]
        newArray.splice(index, 1)
        runInAction(() => {
            this.aliasesArray = newArray
        })
    }

    @action
    updateDrug = async id => {
        const aliases = this.aliasesArray.join('|')
        await drugs.updateDrug({ id, aliases })
    }

    @action
    addAlias = value => {
        const newArray = [...this.aliasesArray]
        newArray.unshift(value)
        runInAction(() => {
            this.aliasesArray = newArray
        })
    }

    @action
    resetDrug = () => {
        this.drug = {}
    }

    @action
    changePage = page => {
        this.loading = true
        const filters = this.paging.filters
        runInAction(() => {
            this.paging.page = page
            this.filters = filters
            this.getDrugs(page)
        })
    }
    @action
    changePageDrugCompaniesNoHealthRight = page => {
        this.loading = true
        const filters_DrugCompaniesNoHealthRight = this.pagingDrugsNoHealthRight.filters_DrugCompaniesNoHealthRight
        runInAction(() => {
            this.pagingDrugsNoHealthRight.page = page
            this.filters_DrugCompaniesNoHealthRight = filters_DrugCompaniesNoHealthRight
        })
    }
    //filter of main page drugs
    @action
    setFilter = (name, value) => {
        const newFilters = { ...this.filters }
        if (!value) {
            delete newFilters[name]
        } else {
            newFilters[name] = value
        }
        runInAction(() => {
            this.filters = { ...newFilters }
        })
    }
    //
    //filter of data shown in popup drug companies
    //
    @action
    setFilterDrugsCompanies = (name, value) => {
        const newFilters = { ...this.filters_drugsCompanies }
        // value = (value && value.length>0) ? value.trim():value;
        newFilters[name] = value
        runInAction(() => {
            this.filters_drugsCompanies = newFilters
            this.filteredDrugCompaniesList()
        })
    }
    //
    //filter of data shown in popup drug companies not related to drug table
    //
    @action
    setFilterDrugCompaniesNoHealthRight = (name, value) => {
        const newFilters = { ...this.filters_DrugCompaniesNoHealthRight }
        //  value = (value && value.length>0) ? value.trim():value;

        newFilters[name] = value
        runInAction(() => {
            this.filters_DrugCompaniesNoHealthRight = newFilters
        })
    }
    @action
    resetFilter_DrugCompanies = () => {
        this.filters_drugsCompanies = { company_id: null }
        this.errors = { serverErrors: null }
    }
    @action
    resetFilterDrugCompaniesNoHealthRight = () => {
        this.filters_DrugCompaniesNoHealthRight = {
            drug_id: null,
            drug_company_type: null,
            company_name: null,
            policy_name: null
        }
        this.errors = { serverErrors: null }
    }
    @action
    resetFilters = () => {
        this.filters = {}
        this.errors = { serverErrors: null }
    }
    @action
    filteredDrugCompaniesList = () => {
        if (!this.filters_drugsCompanies.company_id) {
            this.filtered_DrugCompanies = this.list_DrugCompanies
        } else {
            let _filterId = this.filters_drugsCompanies.company_id
            this.filtered_DrugCompanies = this.list_DrugCompanies.filter(function(el) {
                return el.company_id == _filterId
            })
        }
    }
}

export default remotedev(new drugsStore())
